import React from 'react';
import {X1Language, X2AgeCategory, X3Level, X4Unit, X5Lesson} from '../../../domain';
import {SingleSelect} from './base/SingleSelect';

interface BaseContentType {
  Id: number;
  Name: string;
}

type SelectOptions<T extends BaseContentType> = {
  options: readonly T[];
  value: T | null;
  onChange: (t: T | null) => void;
  onBlur?: () => void;
};

function optionLabel<T extends BaseContentType>(t: T): string {
  return t.Name;
}

function optionId<T extends BaseContentType>(t: T): string {
  return t.Id.toString(10);
}

export class X1LanguageSelect extends React.Component<SelectOptions<X1Language>> {
  render() {
    return (
      <SingleSelect<X1Language> options={this.props.options}
                                getValue={optionId}
                                getLabel={optionLabel}
                                value={this.props.value}
                                onChange={this.props.onChange}
                                onBlur={this.props.onBlur}/>);
  }
}

export class X2AgeCategorySelect extends React.Component<SelectOptions<X2AgeCategory>> {
  render() {
    return (
      <SingleSelect<X2AgeCategory> options={this.props.options}
                                   getValue={optionId}
                                   getLabel={optionLabel}
                                   value={this.props.value}
                                   onChange={this.props.onChange}
                                   onBlur={this.props.onBlur}/>);
  }
}

export class X3LevelSelect extends React.Component<SelectOptions<X3Level>> {
  render() {
    return (
      <SingleSelect<X3Level> options={this.props.options}
                             getValue={optionId}
                             getLabel={optionLabel}
                             value={this.props.value}
                             onChange={this.props.onChange}
                             onBlur={this.props.onBlur}/>);
  }
}

export class X4UnitSelect extends React.Component<SelectOptions<X4Unit>> {
  render() {
    return (
      <SingleSelect<X4Unit> options={this.props.options}
                            getValue={optionId}
                            getLabel={optionLabel}
                            value={this.props.value}
                            onChange={this.props.onChange}
                            onBlur={this.props.onBlur}/>);
  }
}

export class X5LessonSelect extends React.Component<SelectOptions<X5Lesson>> {
  render() {
    return (
      <SingleSelect<X5Lesson> options={this.props.options}
                              getValue={optionId}
                              getLabel={optionLabel}
                              value={this.props.value}
                              onChange={this.props.onChange}
                              onBlur={this.props.onBlur}/>);
  }
}

